import { useState, useEffect, useRef } from "react";
import "./TranscriptionBubble.css";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import Select from "react-select";
import { FaPlay, FaPlus } from "react-icons/fa";

const TranscriptionBubble = ({ msg, audioRef, searchTerm, isActive, isSelected, criteriaOptions = [], onAddCriteria }) => {
    const rowRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const [addingCriteria, setAddingCriteria] = useState(false);
    const canAddCriteria = msg.side === "agent";
    const availableCriteriaOptions = criteriaOptions.filter(
        option => !(msg.criterias || []).includes(option.value)
    );
    const formatTime = (time) => {
        const m = Math.floor(time / 60);
        const s = Math.floor(time % 60);
        return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
    };

    const handlePlay = () => {
        if (audioRef?.current?.audio?.current) {
            audioRef.current.audio.current.currentTime = msg.start;
            audioRef.current.audio.current.play();
        }
        setOpen(!open);
    };

    const handleEdit = () => {
        console.log("Edit clicked");
    };

    const handleCopy = () => {
        console.log("Copy clicked");
    };

    const handleSelectCriteria = (option) => {
        setAddingCriteria(false);
        if (!option) return;
        onAddCriteria?.(msg, option.value);
    };

    const criteriaSelectStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: 32,
            minWidth: 180,
            backgroundColor: "var(--pure-white)",
            borderColor: state.isFocused ? "var(--main)" : "var(--gray)",
            boxShadow: "none",
            "&:hover": { borderColor: "var(--main)" }
        }),
        menu: (base) => ({
            ...base,
            backgroundColor: "var(--pure-white)",
            zIndex: 20
        }),
        menuList: (base) => ({
            ...base,
            maxHeight: 200
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected
                ? "var(--main)"
                : state.isFocused
                    ? "var(--light-secondary)"
                    : "var(--pure-white)",
            color: state.isSelected ? "var(--pure-white)" : "var(--main)",
            cursor: "pointer"
        }),
        singleValue: (base) => ({ ...base, color: "var(--main)" }),
        placeholder: (base) => ({ ...base, color: "var(--main)", opacity: 0.6 }),
        input: (base) => ({ ...base, color: "var(--main)" }),
        indicatorSeparator: () => ({ display: "none" }),
        dropdownIndicator: (base) => ({ ...base, color: "var(--main)" })
    };
    const getHighlightedText = (text) => {
        if (!searchTerm) return text;
        const regex = new RegExp(`(${searchTerm})`, "i"); // pas le g
        const parts = text.split(new RegExp(`(${searchTerm})`, "i"));
        console.log(text)
        console.log(parts)
        return parts.map((part, i) =>
            part?.toLowerCase() === searchTerm?.toLowerCase() ? <mark className="hightlight-transcription-bubble" key={i}>{part}</mark> : part
        );
    };
    // Follows playback: when this bubble becomes the currently-playing
    // segment (isActive, already driving the orange highlight), scroll it
    // into view. isActive only flips true/false at segment boundaries, so
    // this fires once per segment rather than on every audio timeupdate.
    useEffect(() => {
        if (isActive) {
            rowRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
        }
    }, [isActive]);
    return (
        <div ref={rowRef} className={`transcription-row ${msg.side}`} data-start={msg.start}>
            <Tippy
                interactive
                visible={tooltipVisible}
                placement="top"
                onClickOutside={() => { setTooltipVisible(false); setAddingCriteria(false); }}
                content={
                    <div className="tooltip-menu">
                        <button onClick={handlePlay}><FaPlay /></button>
                        {/*
                        <button onClick={handleEdit}>Edit</button>
                    <button onClick={handleCopy}>Copy</button>
                    */}
                        {onAddCriteria && canAddCriteria && (
                            addingCriteria ? (
                                <Select autoFocus menuIsOpen options={availableCriteriaOptions}
                                    onChange={handleSelectCriteria} onMenuClose={() => setAddingCriteria(false)}
                                    placeholder="Add criteria..." isSearchable
                                    styles={criteriaSelectStyles} classNamePrefix="add-criteria-select" className="add-criteria-select-container"
                                />
                            ) : (
                                <button onClick={() => setAddingCriteria(true)} title="Add criteria">
                                    <FaPlus />
                                </button>
                            )
                        )}
                    </div>
                }
            >
                <div className={`transcription-bubble ${isActive ? "active" : ""} ${isSelected ? "selected" : ""}`} onClick={() => setTooltipVisible(!tooltipVisible)}>
                    {getHighlightedText(msg.text)}
                    <div className="transcription-meta">
                        {msg.side === "agent" ? "Agent" : "Client"} - {formatTime(msg.start)}
                    </div>
                </div>
            </Tippy >
        </div >
    );
};

export default TranscriptionBubble;